import {JsonProperty} from 'json-typescript-mapper';

export enum MarketAccountingEntryType {
  Booth = <any>'Booth',
  BoothTotal = <any>'BoothTotal',
  Expense = <any>'Expense',
  ExpenseTotal = <any>'ExpenseTotal',
  Total = <any>'Total',
  TotalTotal = <any>'TotalTotal',
  DeviceRefund = <any>'DeviceRefund',
};

export class MarketAccountingEntry {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('description')
  public description?: string;

  @JsonProperty('type')
  public type?: MarketAccountingEntryType;

  @JsonProperty('order')
  public order?: number;

  @JsonProperty('amount')
  public amount?: number;

  @JsonProperty('boothContractType')
  public boothContractType?: string;

  @JsonProperty('partialPayment')
  public partialPayment?: boolean;

  @JsonProperty('image')
  public image?: string;

  @JsonProperty('image2')
  public image2?: string;

  @JsonProperty('image3')
  public image3?: string;

  @JsonProperty('imageUploaded')
  public imageUploaded?: boolean;

  @JsonProperty('image2Uploaded')
  public image2Uploaded?: boolean;

  @JsonProperty('image3Uploaded')
  public image3Uploaded?: boolean;

  constructor() {
    this.id = void 0;
    this.description = void 0;
    this.order = void 0;
    this.amount = void 0;
    this.type = void 0;
    this.boothContractType = void 0;
    this.partialPayment = void 0;
    this.image = void 0;
    this.image2 = void 0;
    this.image3 = void 0;
    this.imageUploaded = void 0;
    this.image2Uploaded = void 0;
    this.image3Uploaded = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/market-accounting-entry.model.ts